export function toRoleSlug(role) {
  return role
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9\s]/g, '')
    .replace(/\s+/g, '-');
}

export const DEFAULT_QUESTIONS = [
  'Tell us about yourself and what attracted you to this role.',
  'Describe a time you had to deal with a challenging situation at work — what did you do?',
  'How do you prioritise tasks when you have multiple things to get done?',
  'What does doing a good job look like to you?',
  'How do you prefer to receive feedback?',
  'Tell me about a time you had to work under pressure. How did you handle it?',
  'What do you know about our business, and why do you want to work here?',
  'What are your availability and any limitations we should know about?',
];

const LIBRARY = {
  'cafe-manager': [
    'Walk me through how you would open the cafe on a busy Monday morning.',
    'How do you handle a staff member who is consistently late or underperforming?',
    'Describe a time you had to resolve a complaint from a difficult customer.',
    'How do you manage stock, wastage, and ordering to keep costs under control?',
    'What does a great customer experience look like to you, and how do you maintain it across shifts?',
    'Tell me about your experience with rostering — how do you balance coverage and staff preferences?',
    'How have you handled a situation where you were short-staffed during a busy service period?',
    'What food safety or health and safety requirements are you familiar with?',
  ],
  'barista': [
    'Walk me through your approach to making a consistently great espresso.',
    'How do you handle a customer who is unhappy with their coffee?',
    'Describe a time when service got very busy — how did you stay on top of it?',
    'What experience do you have with different brewing methods or coffee equipment?',
    'How do you ensure cleanliness and hygiene standards are met throughout the shift?',
    'Tell me about working as part of a cafe team — what role do you naturally take?',
    'How do you handle a situation where a colleague isn\'t pulling their weight during a rush?',
    'What would you do if you ran low on a key ingredient mid-service?',
  ],
  'chef': [
    'Walk me through how you would manage prep for a busy dinner service with a small team.',
    'How do you handle a situation where a key ingredient hasn\'t arrived on time?',
    'Describe your approach to maintaining food quality and consistency across multiple dishes.',
    'Tell me about your experience with menu development or seasonal changes.',
    'How do you manage kitchen health and safety requirements in a practical way?',
    'Describe a time you had a conflict with front-of-house staff — how did you resolve it?',
    'How do you manage kitchen costs, including food waste and portion control?',
    'What would you do if a team member made a food safety error during service?',
  ],
  'kitchen-hand': [
    'Tell me about the busiest kitchen environment you\'ve worked in — what was your job and how did you keep up?',
    'How do you make sure your section stays clean and organised during a busy service?',
    'Describe a time you were given a task you hadn\'t done before in a kitchen — how did you handle it?',
    'What does following food safety and hygiene rules look like for you on a typical shift?',
    'Tell me about a time you were running behind or couldn\'t keep up — what happened and what did you do?',
    'How do you work alongside chefs and other kitchen staff when things are moving fast?',
    'What would you do if you noticed something in the kitchen that wasn\'t clean or safe?',
    'Tell me about a time someone at work pointed out something you\'d done wrong. How did you take it?',
  ],
  'retail-assistant': [
    'Tell me about a time you gave great customer service — what did you do and why did it matter?',
    'How do you stay motivated and engaged during slow periods on the shop floor?',
    'Describe a time a customer was unhappy — how did you handle it?',
    'Have you worked with POS systems or cash handling before? Walk me through your experience.',
    'How do you handle a situation where a customer wants to return something outside of policy?',
    'What does a well-presented store look like to you, and how do you contribute to that?',
    'Tell me about working as part of a retail team — how do you support your colleagues?',
    'How do you manage your time when you have multiple tasks and the floor is busy?',
  ],
  'sales-assistant': [
    'Tell me about a successful sale you made — what was your approach?',
    'How do you build rapport with a customer who seems disinterested?',
    'Describe a time you had to deal with a difficult or demanding customer.',
    'How do you stay motivated when you\'re having a slow sales day?',
    'What do you know about active listening, and how do you use it in a sales context?',
    'How do you handle objections from a customer who is hesitant to buy?',
    'Tell me about your experience with product knowledge — how do you keep yourself informed?',
    'What would you do if a customer asked you something about a product you didn\'t know?',
  ],
  'builder': [
    'Walk me through how you approach a new residential project from start to finish.',
    'Describe a time you identified a safety hazard on site — what did you do?',
    'How do you read and interpret plans and specifications?',
    'Tell me about your experience working with subcontractors or other trades on site.',
    'How do you ensure your work meets the required standard before sign-off?',
    'Describe a time when a project ran into problems — how did you handle it?',
    'What\'s your approach to keeping the site tidy and organised?',
    'How do you manage your time and tasks when juggling multiple jobs?',
  ],
  'labourer': [
    'Tell me about your previous experience in a physical or outdoor work environment.',
    'How do you approach health and safety on a work site?',
    'Describe a time you had to follow detailed instructions from a supervisor — how did you ensure you got it right?',
    'How do you handle working in varying weather conditions?',
    'Tell me about working as part of a team on a manual task — what role did you take?',
    'What would you do if you spotted a potential hazard that your supervisor hadn\'t noticed?',
    'How do you keep your energy and focus up during a physically demanding shift?',
    'Do you have any relevant licences, certificates, or tickets? Walk me through them.',
  ],
  'office-administrator': [
    'Walk me through how you manage your workload when you have several tasks with similar deadlines.',
    'Describe your experience with scheduling, calendar management, or coordinating meetings.',
    'Tell me about a time you had to handle a difficult phone call or challenging person — how did you manage it?',
    'What software or tools do you use for document management and communications?',
    'How do you ensure accuracy when dealing with data entry or record keeping?',
    'Describe a time you improved an administrative process or spotted an inefficiency — what did you do?',
    'How do you handle conflicting requests from different team members?',
    'Tell me about your experience supporting senior staff or managing upwards.',
  ],
  'driver': [
    'Walk me through how you start your shift — what checks do you carry out before you begin?',
    'How do you plan your route when you have multiple deliveries or pickups?',
    'Describe a time something unexpected happened on a run — how did you handle it?',
    'How do you interact with customers when delivering — especially if there\'s a problem?',
    'What is your understanding of the hours of service and fatigue management rules?',
    'Tell me about a time you had to deal with a vehicle issue — what did you do?',
    'How do you stay focused and alert on long or repetitive runs?',
    'What\'s your approach to loading and securing goods safely?',
  ],
  'support-worker': [
    'Tell me why you want to work in a support role — what draws you to this kind of work?',
    'Describe a time you had to respond to a person in distress or a difficult emotional situation.',
    'How do you maintain professional boundaries while still being warm and caring?',
    'Tell me about your experience following individualised care or support plans.',
    'How do you approach situations where a client is reluctant or resistant to support?',
    'Describe a time you had to work closely with family members or external agencies.',
    'How do you document your work accurately and maintain confidentiality?',
    'What would you do if you had a concern about a client\'s wellbeing or safety?',
  ],
  'childcare-worker': [
    'Tell me why you want to work with young children — what draws you to early childhood education?',
    'Walk me through how you would plan an activity for a mixed-age group of children.',
    'Describe a time you had to manage a child who was upset or showing challenging behaviour.',
    'How do you communicate with parents and whanau in a respectful and informative way?',
    'What does a safe and stimulating environment look like to you in an ECE setting?',
    'Tell me about your experience with the NZ ECE curriculum — Te Whāriki.',
    'How do you document learning and development in a way that\'s meaningful for families?',
    'Describe a time you identified a concern about a child\'s wellbeing — what did you do?',
  ],
};

const SLUG_ALIASES = {
  'cafe-manager': ['cafe-manager', 'coffee-shop-manager', 'cafe-supervisor'],
  'barista': ['barista', 'coffee-maker', 'coffee-specialist'],
  'chef': ['chef', 'head-chef', 'sous-chef', 'kitchen-manager', 'cook'],
  'kitchen-hand': ['kitchen-hand', 'kitchenhand', 'kitchen-assistant', 'kitchen-hand-dishwasher', 'kitchen-attendant', 'dishwasher'],
  'retail-assistant': ['retail-assistant', 'retail-associate', 'shop-assistant', 'store-assistant', 'retail-sales-assistant'],
  'sales-assistant': ['sales-assistant', 'sales-associate', 'sales-consultant', 'sales-representative'],
  'builder': ['builder', 'carpenter', 'construction-worker', 'painter', 'roofer', 'tiler'],
  'labourer': ['labourer', 'laborer', 'general-labourer', 'site-labourer', 'factory-worker', 'warehouse-worker'],
  'office-administrator': ['office-administrator', 'administrator', 'admin', 'receptionist', 'office-manager', 'executive-assistant', 'personal-assistant', 'pa', 'coordinator', 'office-coordinator'],
  'driver': ['driver', 'delivery-driver', 'truck-driver', 'courier', 'van-driver'],
  'support-worker': ['support-worker', 'carer', 'care-worker', 'aged-care-worker', 'disability-support-worker', 'health-support-worker'],
  'childcare-worker': ['childcare-worker', 'ece-teacher', 'teacher-aide', 'early-childhood-teacher', 'daycare-worker', 'childcare-assistant'],
};

function resolveSlug(slug) {
  for (const [canonical, aliases] of Object.entries(SLUG_ALIASES)) {
    if (aliases.some((alias) => slug.includes(alias) || alias.includes(slug))) {
      return canonical;
    }
  }
  return null;
}

export function getQuestionsForRole(roleSlug) {
  const resolved = resolveSlug(roleSlug);
  if (resolved && LIBRARY[resolved]) {
    return LIBRARY[resolved];
  }
  return DEFAULT_QUESTIONS;
}

export function isDefaultQuestions(questions) {
  if (!questions || questions.length !== DEFAULT_QUESTIONS.length) return false;
  return questions.every((q, i) => q === DEFAULT_QUESTIONS[i]);
}
